/**
 * Mobil: shake ile CommandSpotlight açma
 *
 * Kurallar:
 * - Permission prompt'u shake ile asla tetikleme.
 * - Kullanıcı önce Ayarlar > İzinler üzerinden manuel olarak aktif etmeli.
 */

import { useEffect } from "react";
import { useShake } from "@/hooks";
import { isMobile } from "@/lib/is-mobile";
import { readShakeSpotlightPermissionState } from "@/lib/shake-spotlight-permission";
import useAuthStore from "@/store/use-auth-store";
import { useSlashCommandStore } from "../store/slash-command-store";

export const useSpotlightShake = () => {
  const { isSpotlightOpen, openSpotlight } = useSlashCommandStore();

  // Not: Bu state store'da tutulmuyor; user "İzinler" ekranından aktif edince localStorage'a yazılıyor.
  // Biz burada sadece okuyoruz (no prompt).
  const permissionState = readShakeSpotlightPermissionState();

  const shouldEnableShake =
    isMobile() &&
    permissionState.userEnabled &&
    (permissionState.motionPermission === "granted" ||
      permissionState.motionPermission === "unknown"); // unknown: Android/Chrome gibi permission gerekmeyen ortamlarda enable sonrası "granted" yazıyoruz, ama güvenli olsun

  const { isSupported } = useShake({
    enabled: shouldEnableShake,
    // Daha az hassas: daha yüksek eşik + kısa pencerede 2 hit + daha uzun cooldown
    thresholdG: 7.0,
    minShakeCount: 4,
    windowMs: 450,
    cooldownMs: 1200,
    onShake: () => {
      // Komutlar auth gerektirir; misafir oturumlarda shake tetiklenmemeli
      if (!useAuthStore.getState().isAuthenticated()) return;
      if (!isSpotlightOpen) openSpotlight();
    },
  });

  // Eğer cihaz motion desteklemiyorsa kullanıcı state'i değiştirmiyoruz (sadece no-op).
  useEffect(() => {
    if (!isSupported) return;
  }, [isSupported]);
};
